import { ErrorFallbackProps } from '~/components/Error';

export const AdventureExploreErrorFallback = ({ error }: ErrorFallbackProps) => {
  switch (error.message) {
    case 'EMPTY':
      return null;
    default:
      throw error;
  }
};
